import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";

export default function NotFoundPage() {
  return (
    <>
      <SEO title="Page Not Found | Polishing Singapore" description="The requested Polishing Singapore page was not found." canonical={null} noindex />
      <PageHero title="Page not found" description="This route is not available. Use the service index to continue." />
      <section className="section-pad">
        <div className="section-shell">
          <Link to="/services" className="btn-primary">View services</Link>
        </div>
      </section>
    </>
  );
}
